import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { HelpComponent } from '../help.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-help-settings',
  standalone: true,
  templateUrl: './help-settings.component.html',
  styleUrls: ['./help-settings.component.css'],
})
export class HelpSettingsComponent {
  readonly parent = input.required<HelpComponent>();
}
